// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
interface GPUModel {
  model: string;
  number: number;
}

export interface ClusterEngineDTO {
  role: number;
  engineName: string;
  passMarkScore: number;
  currentTaskId: string;
  numberOfPendingTasks: number;
  startDate: string;
  avgCpu: number;
  avgGpu: number;
  ramAmount: number;
  lastUpdated: string;
  processorName?: string;
  numberOfProcessors?: number;
  gpuModels?: Array<GPUModel>;
}

export class ClusterEngine {
  role: number;
  engineName: string;
  passMarkScore: number;
  currentTaskId: string;
  numberOfPendingTasks: number;
  startDate: string;
  avgCpu: number;
  avgGpu: number;
  ramAmount: number;
  lastUpdated: string;
  numberOfProcessors?: number;
  processorName?: string;
  gpuModels?: Array<GPUModel>;

  constructor(dto: Partial<ClusterEngineDTO>) {
    this.update(dto);
  }

  get asJson(): ClusterEngineDTO {
    return {
      role: this.role,
      numberOfPendingTasks: this.numberOfPendingTasks,
      processorName: this.processorName,
      numberOfProcessors: this.numberOfProcessors,
      gpuModels: this.gpuModels,
      ramAmount: this.ramAmount,
      engineName: this.engineName,
      currentTaskId: this.currentTaskId,
      startDate: this.startDate,
      passMarkScore: this.passMarkScore,
      avgCpu: this.avgCpu,
      avgGpu: this.avgGpu,
      lastUpdated: this.lastUpdated,
    };
  }

  update(newData: Partial<ClusterEngineDTO>): ClusterEngineDTO {
    const allData = { ...this.asJson, ...newData };

    Object.assign(this, allData);

    return this.asJson;
  }
}